import { Box, Button, Flex, Heading, Tooltip } from '@chakra-ui/react';
import { mdiPlus } from '@mdi/js';
import EmptyState from 'features/common/components/EmptyState';
import { PortalIcon } from 'features/common/components/PortalIcon';
import { useMemo } from 'react';
import { DataTable } from '../../../../../common/components/DataTable';
import { SitecoreContextResourceType } from '../../../../types/types';
import { generateResourcesTableData, columns } from './helpers';

export const ResourcesTable = ({
  resources = [],
  isLoading,
  onAddSearchResource,
  isAddSearchResourceDisabled,
  addSearchResourceDisabledReason,
}: {
  resources?: SitecoreContextResourceType[];
  isLoading: boolean;
  onAddSearchResource?: () => void;
  isAddSearchResourceDisabled?: boolean;
  addSearchResourceDisabledReason?: string;
}) => {
  const tableData = useMemo(
    () => generateResourcesTableData(resources),
    [resources],
  );

  const initialSortBy = useMemo(() => [{ id: 'name', desc: false }], []);

  return (
    <Flex direction='column' gap={6}>
      <Flex justifyContent='space-between' alignItems='center'>
        <Heading size='md' data-testid='app-details-header-app-name'>
          Resources
        </Heading>
        {onAddSearchResource && (
          <Tooltip
            label={addSearchResourceDisabledReason}
            isDisabled={
              !isAddSearchResourceDisabled || !addSearchResourceDisabledReason
            }
            hasArrow
            shouldWrapChildren
            maxW='3xs'
            textAlign='center'
            placement='bottom-end'
          >
            <Button
              variant='outline'
              leftIcon={<PortalIcon path={mdiPlus} />}
              onClick={onAddSearchResource}
              isDisabled={isAddSearchResourceDisabled}
              data-testid='add-search-resource-btn'
              data-behavior-analytics-id='Add Search Resource button - Context ID details page'
            >
              Add Search resource
            </Button>
          </Tooltip>
        )}
      </Flex>
      {tableData.length || isLoading ? (
        <Box overflowX='auto' width='100%'>
          <DataTable
            columns={columns}
            onChange={() => {
              /* autoSort handles sorting internally */
            }}
            isLoading={isLoading}
            pageSize={5}
            data={tableData}
            sortBy={initialSortBy}
            page={1}
            pagination='hidden'
            data-behavior-analytics-feature='resources table'
          />
        </Box>
      ) : (
        <Flex my={5}>
          <EmptyState
            text='No resources added'
            description='Add a resource'
            boxSize='20'
            dataTestId='no-resource-container'
          />
        </Flex>
      )}
    </Flex>
  );
};
